<div class="brand-area-one ptb--100">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="brand-style-one">
          <div class="left-title">
            <h6 class="title">Parceiros:</h6>
          </div>
          <div
            class="swiper mySwiper-category-1 swiper-data"
            data-swiper='{
                              "spaceBetween":30,
                              "slidesPerView":6,
                              "loop": true,
                              "speed": 1500,
                              "autoplay":{
                                  "delay":"4000"
                              },
                              "breakpoints":{
                              "0":{
                                  "slidesPerView":2,
                                  "spaceBetween":30},
                              "320":{
                                  "slidesPerView":2,
                                  "spaceBetween":30},
                              "480":{
                                  "slidesPerView":3,
                                  "spaceBetween":30},
                              "640":{
                                  "slidesPerView":4,
                                  "spaceBetween":30},
                              "840":{
                                  "slidesPerView":4,
                                  "spaceBetween":30},
                              "1140":{
                                  "slidesPerView":6,
                                  "spaceBetween":30}
                              }
                          }'
          >
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="brand-area">
                  <img
                    src="assets/images/brand/google_education.png"
                    alt="brand"
                  />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="brand-area">
                  <img src="assets/images/brand/azure.png" alt="brand" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="brand-area">
                  <img src="assets/images/brand/qa_coders.png" alt="brand" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="brand-area">
                  <img src="assets/images/brand/cisco.png" alt="brand" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="brand-area">
                  <img src="assets/images/brand/github.png" alt="brand" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="brand-area">
                  <img src="assets/images/brand/acert.png" alt="brand" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="brand-area">
                  <img src="assets/images/brand/abramti.png" alt="brand" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="brand-area">
                  <img src="assets/images/brand/jetbrains.png" alt="brand" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="brand-area">
                  <img src="assets/images/brand/aws.png" alt="brand" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
